import { render } from "./EventCard.vue?vue&type=template&id=e758ad54&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=e758ad54&scoped=true&lang=css"

import exportComponent from "E:\\VUE\\real-world\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e758ad54"]])

export default __exports__